import logo from './logo.svg';
import './App.css';
import players from './fakeData/players.json';
import { useEffect, useState } from 'react';
import Player from './components/Player/Player';
import Team from './components/Team/Team';

function App() {
  const [player, setPlayer] = useState([]);
  const [team, setTeam] = useState([]); 

  useEffect(() => {
    setPlayer(players);
    // console.log(players);
  }, [])

  const handleAddPlayer = (player) => {
    const newPlayer = [...team, player];
    setTeam(newPlayer);
  };
  return (
    <div className="App">
      <h1>All Player's Loaded: {player.length} <br/> (Select Your Favourite Players for Bangladesh Team)</h1>
      <Team team={team}></Team>
      {
        players.map(player => <Player player={player} key={player.id} handleAddPlayer={handleAddPlayer}></Player>)
      }
     

     
      
    </div>
  );
}

export default App;
